module.exports = __webpack_public_path__ + "img/feather-primary.60fbd313.svg";